/**
 * After a deploy, a tab still running the old build asks for page files
 * (hashed chunks) that no longer exist. Those imports fail with errors like
 * "Failed to fetch dynamically imported module". Reloading fetches the new
 * build; a short guard stops a reload loop if the files are truly missing.
 */
const KEY = 'saadhan.reloadedForUpdate'
const GUARD_MS = 30_000

export function isStaleBuildError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error ?? '')
  return /dynamically imported module|Importing a module script failed|Unable to preload CSS|MIME type/i.test(message)
}

/** Reloads the page once; false if it just did (or can't tell), so the caller shows the error. */
export function reloadForUpdate(): boolean {
  try {
    const last = Number(sessionStorage.getItem(KEY) ?? 0)
    if (Date.now() - last < GUARD_MS) return false
    sessionStorage.setItem(KEY, String(Date.now()))
  } catch {
    return false
  }
  window.location.reload()
  return true
}
